import { SuggestionSelectionProps } from '@carvana/merch-search-bar';
import { useContext } from 'react';
import { StickySearchContext } from '@/Search/components/StickySearchProvider';
import { apikUrl, assetsUrl } from '~/constants/environment';
import SearchSource from '~/constants/SearchSource';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import SavedSearchesContext from '~/contexts/SavedSearchesContext';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';
import { useUserLocation } from '~/contexts/UserContext';
import decodeCvnaId from '~/utilities/cvnaId';

export default function useSearchBarProps() {
  const { setAppliedFilters } = useContext(AppliedFiltersContext);
  const { savedSearches } = useContext(SavedSearchesContext);
  const { setSearchSource, setKeywordSuggestion } = useContext(
    SearchEventsDataContext
  );
  const { isStickySearchBar } = useContext(StickySearchContext);
  const trackEvent = useTrackEvent();
  const { state = '' } = useUserLocation();

  return {
    apiBaseUrl: apikUrl,
    cdnBaseUrl: assetsUrl,
    // customEventData: { currentSearchRequestId: searchRequestId },
    geolocationState: state,
    onSuggestionSelection: ({
      cvnaId,
      eventData
    }: SuggestionSelectionProps) => {
      const searchSource = SearchSource[eventData.textSource ?? ''];
      if (searchSource) {
        setSearchSource(searchSource);
      }
      setKeywordSuggestion({
        ...eventData,
        isStickySearchbar: isStickySearchBar
      });
      setAppliedFilters(decodeCvnaId(cvnaId)?.filters ?? {});
    },
    refSource: 'srp',
    savedSearches,
    trackEvent
  };
}
